module.exports = __webpack_public_path__ + "static/media/ACT_WorkKeys_Color_Digital.94fce8ef.svg";